import _ from "lodash";
import React from "react";
import PropTypes from "prop-types";
import classes from "./ResourceBank.scss";
import ResourceList from "./ResourceList";
import ResourceFooter from "./ResourceFooter";
import UIModal from "UIComponents/UIModal";
import SearchBar from "UIComponents/SearchBar";
import { generateRandomId, getImageDimensions } from "Utils";
import ResourceBankV2 from "./ResourceBankV2";

class ResourceBank extends React.Component {
  state = { scrollTopCounter: 0 };
  componentDidMount() {
    this.props.initaliseResourceBankComponent(this.props.id);
    document.addEventListener("keydown", this.handleEscKey, false);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleEscKey, false);
  }

  resetResourceBank = () => {
    this.props.initaliseResourceBankComponent(this.props.id);
  };

  handleEscKey = e => {
    if (e.keyCode == 27) {
      this.onCloseClick();
    }
  };

  onCloseClick = () => {
    if (this.props.closeResource) {
      this.props.closeResource();
    }
  };

  getSendObject = async ({ file, fileUrl, isLink = false, title }) => {
    const mimeType = "image/png";
    const url = isLink ? file.url : fileUrl;
    const attachmentType = "IMAGE";
    const dimensions = await getImageDimensions({ url, type: attachmentType });

    return {
      type: attachmentType,
      url: url,
      name: title,
      mimeType: mimeType,
      metadata: { size: _.get(file, "size", 0), ...dimensions },
    };
  };

  updateFileCount(count, isError = false) {
    if (this.props.updateFilesCount) {
      this.props.updateFilesCount(count, isError);
    }
  }

  uploadImageToS3 = async ({
    file,
    uploadId,
    parentType,
    parentId,
    sendObj,
    title,
  }) => {
    const { promise } = this.props.uploadFile({
      file,
      uploadId,
      startProgress: 50,
      parentType: parentType,
      parentId: parentId,
      attachment: sendObj,
    });

    try {
      const item = await promise;
      const newSendObj = await this.getSendObject({
        file,
        title,
        fileUrl: item,
      });
      if (this.props.onContentUploaded) {
        await this.props.onContentUploaded(newSendObj);
      }
      if (this.props.onSingleContentUploaded) {
        await this.props.onSingleContentUploaded(newSendObj, uploadId);
      }
      this.props.removeProgressElement({ id: uploadId });
      this.updateFileCount(-1);
    } catch (e) {
      this.updateFileCount(-1, true);
    }
  };

  onResourceDownloaded = async ({
    file,
    uploadId,
    thumbURL,
    title,
    downloadUrl,
  }) => {
    const { parentId, parentType, addUnsplashAnalytics } = this.props;

    const sendObj = await this.getSendObject({
      file,
      fileUrl: thumbURL,
      isLink: false,
      title,
    });

    this.props.onDropContent?.({ ...sendObj, id: uploadId });

    await Promise.all([
      this.uploadImageToS3({
        file,
        uploadId,
        parentId,
        parentType,
        sendObj,
        title,
      }),
    ]);
  };

  onAddClick = () => {
    const { selectedResources, downloadFromUrl } = this.props;
    selectedResources.forEach(resource => {
      const fileUploadId = generateRandomId();
      this.updateFileCount(1);
      const startProgress = 50;

      const { url, thumbURL, title, downloadUrl } = resource;

      downloadFromUrl({
        downloadUrl: url,
        fileUploadId,
        startProgress,
        onLoaded: fileBlob => {
          this.onResourceDownloaded({
            file: fileBlob,
            uploadId: fileUploadId,
            thumbURL,
            startProgress,
            title,
            downloadUrl,
          });
        },
        onContentLoadFailed: async ({ isCancelled }) => {
          this.updateFileCount(-1, true);
        },
      });
    });

    if (this.props.onAddClick) {
      this.props.onAddClick(this.props.selectedResources);
    }
    this.onCloseClick();
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!_.isEqual(nextProps.filters, this.props.filters)) {
      this.props.clearResourceBankSelectedResources(this.props.id);
      this.setState({ scrollTopCounter: this.state.scrollTopCounter + 1 });
    }
  }

  updateSearchTextInRedux = searchText => {
    const { id } = this.props;
    this.props.updateResourceBankFilters({ searchText }, id);
  };

  render() {
    const {
      isData,
      isLoading,
      selectedResources,
      filters,
      getResourceList,
      toggleAllResourceBankFilterItems,
      toggleResourceBankFilterItem,
      loadMoreListData,
      toggleResourceBankSelectedResources,
      id,
      closeResource,
      multi,
      t,
      showNewResourceBank,
      parentId,
      fieldParentType,
      dsVersion,
      fieldParentId,
    } = this.props;

    return showNewResourceBank ? (
      <ResourceBankV2
        onClose={this.onCloseClick}
        selectedResources={selectedResources}
        toggleSelectedResources={toggleResourceBankSelectedResources}
        multi={multi}
        onAddClick={this.onAddClick}
        id={id}
        parentId={parentId}
        fieldParentType={fieldParentType}
        fieldParentId={fieldParentId}
        dsVersion={dsVersion}
      />
    ) : (
      <UIModal
        isOpen={true}
        modalContent={classes.modalContent}
        onRequestClose={closeResource}
      >
        <div className={classes.innerContainer}>
          {/* <div className={classes.leftContainer}>
          <ResourceFilters
            id={id}
            isData={isData}
            isLoading={isLoading}
            getResourceList={getResourceList}
            selected={filters.selected}
            toggleAllResourceBankFilterItems={
              toggleAllResourceBankFilterItems
            }
            toggleResourceBankFilterItem={toggleResourceBankFilterItem}
            onResetClick={() => {
              this.resetResourceBank();
            }}
          />
        </div> */}
          <div className={classes.rightContainer}>
            <div className={classes.searchContainer}>
              <SearchBar
                placeholder={t("search_on_unsplash")}
                searchTerm={filters.searchText}
                changeSearchTerm={this.updateSearchTextInRedux}
                shouldAnimate={false}
                wrapperType={"box"}
                searchOnEnter={true}
              />
            </div>
            <div className={classes.resourceContainer}>
              <ResourceList
                scrollTopCounter={this.state.scrollTopCounter}
                id={id}
                isData={isData}
                isLoading={isLoading}
                getResourceList={getResourceList}
                loadMoreListData={loadMoreListData}
                selectedResources={selectedResources}
                toggleSelectedResources={toggleResourceBankSelectedResources}
                multi={multi}
              />
            </div>
            <div className={classes.rightFooterContainer}>
              <ResourceFooter
                t={t}
                onCancelClick={this.onCloseClick}
                totalSelected={selectedResources.length}
                onAddClick={this.onAddClick}
              />
            </div>
          </div>
        </div>
      </UIModal>
    );
  }
}

export default ResourceBank;

ResourceBank.defaultProps = {
  id: "default",
  multi: true,
  dsVersion: "1.0",
};

ResourceBank.propTypes = {
  id: PropTypes.string,
  onAddClick: PropTypes.func,
  multi: PropTypes.bool,
  dsVersion: PropTypes.string,
};
